import { PAGES } from '@/constants/pages';
import { authService, PermissionScope } from '@/services/AuthService';
import React from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  resource: string | readonly string[];
  scope: PermissionScope | readonly PermissionScope[];
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ resource, scope, children }) => {
    const token =  authService?.parsedToken;
    const authorization =  token?.authorization;

    if (!authService.authenticated || !authorization) {
      authService.logout();
      return null;
    }

    const resources = Array.isArray(resource) ? resource : [resource];
    const scopes = Array.isArray(scope) ? scope : [scope];

    const hasAccess = resources.some(res => 
      scopes.some(s => authorization?.hasPermission(res, s))
    );

    if (!hasAccess) {
      return <Navigate to={PAGES.ERRORS.NOT_FOUND.route} replace />;
    }
  
    return <>{children}</>;
  };
  
export default ProtectedRoute;